import { Component, Host, Prop, h } from '@stencil/core';
import { remCalc } from '../../style';

@Component({
  tag: 'rcm-loader',
  styleUrl: 'rcm-loader.scss',
  shadow: true,
})
export class RcmLoader {
  @Prop() size: string = `${remCalc(96)}rem`;

  @Prop() noMargin: boolean = false;

  render() {
    return (
      <Host>
        <div
          class={`loader ${this.noMargin ? 'loader--noMargin' : ''} `}
          style={{
            width: this.size,
            height: this.size,
          }}
        ></div>
      </Host>
    );
  }
}
